import { useEffect } from 'react';
import EventSettings from '../../../components/EventSettings';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import Button from '../../../components/common/Button';
import { useEventSettingsContext } from '../../../contexts/EventSettingsContext';

const EventsPage = () => {
  const { loadEventData, isLoading, hasError, settings, retry } = useEventSettingsContext();

  useEffect(() => {
    loadEventData();
  }, [loadEventData]);

  return (
    <div className="events-page-container">
      <h1 className="events-page-title">Events</h1>
      {hasError && (
        <div className="events-page-error">
          <p>Couldn’t load your events settings.</p>
          <Button className="events-page-retry" onClick={() => retry()}>
            TRY AGAIN
          </Button>
        </div>
      )}
      {!hasError &&
        (isLoading || !settings ? (
          <div className="events-page-loading">
            <LoadingSpinner />
          </div>
        ) : (
          <EventSettings />
        ))}
    </div>
  );
};

export default EventsPage;
